import React from 'react'
import Link from 'gatsby-link'

import cover from '../img/cover.png'
import ocelli_default from '../img/ocelli-default.png'
import ocelli_alpha from '../img/ocelli-alpha.png'
import ocelli_bravo from '../img/ocelli-bravo.png'
import ocelli_charlie from '../img/ocelli-charlie.png'
import './scopes.homepage.scss'
import { lang } from '../language'

const IndexPage = ({ data }) => {
  const arrayChangelog = data.allTranslationsXlsxChangelog.edges
  const arrayFeatures = data.allTranslationsXlsxFeatures.edges
  const arrayHomepageContent = data.allTranslationsXlsxHomepage.edges
  let introduction, features, presets, support, changelog

  arrayHomepageContent.forEach(function(item) {
    item.node.key == 'introduction' ? introduction = item.node : null
    item.node.key == 'features' ? features = item.node : null
    item.node.key == 'presets' ? presets = item.node : null
    item.node.key == 'support' ? support = item.node : null
    item.node.key == 'changelog' ? changelog = item.node : null
  })

  const support_content = support['content' + lang].replace(/support@brotherspeacock.com/ig, function replace(match) {
    return `<a class="link" href="mailto:${match}">${match}</a>`;
  });

  return (
    <div className="s-homepage">
      <header className="section-header">
        <h1 className="section-title">{ introduction['heading' + lang] }</h1>
        <p className="section-description">{ introduction['content' + lang] }</p>
        <img className="section-image" src={ cover }/>
      </header>

      <section className="homepage-section">
        <h2 className="section-title">{ features['heading' + lang] }</h2>
        <ul className="features-container">
          {arrayFeatures.map(({ node }, index) =>
            <li className="feature" key={ index }>
              <span className="feature-icon"><i className="material-icons">star_border</i></span>
              <span className="feature-title">{ node['feature' + lang] }</span>
            </li>
          )}
        </ul>
      </section>

      <section className="homepage-section">
        <h2 className="section-title">{ presets['heading' + lang] }</h2>
        <p className="section-description">{ presets['content' + lang] }</p>
        <ul className="presets-container">
          <li className="preset">
            <a className="preset-link" target="_blank" href="http://ocelliocellus-theme.webshopapp.com">
              <img src={ ocelli_default } width="250" height="250" alt="Ocelli Ocellus Default"/>
              <p className="preset-title">Ocelli Ocellus</p>
            </a>
          </li>
          <li className="preset">
            <a className="preset-link" target="_blank" href="http://ocelliocellus-preset-1-theme.webshopapp.com">
              <img src={ ocelli_alpha } width="250" height="250" alt="Ocelli Ocellus Default"/>
              <p className="preset-title">Ocelli Alpha</p>
            </a>
          </li>
          <li className="preset">
            <a className="preset-link" target="_blank" href="http://ocelliocellus-preset-2-theme.webshopapp.com">
              <img src={ ocelli_bravo } width="250" height="250" alt="Ocelli Ocellus Default"/>
              <p className="preset-title">Ocelli Bravo</p>
            </a>
          </li>
          <li className="preset">
            <a className="preset-link" target="_blank" href="http://ocelliocellus-preset-3-theme.webshopapp.com">
              <img src={ ocelli_charlie } width="250" height="250" alt="Ocelli Ocellus Default"/>
              <p className="preset-title">Ocelli Charlie</p>
            </a>
          </li>
        </ul>
      </section>

      <section className="homepage-section">
        <h2 className="section-title">{ support['heading' + lang] }</h2>
        <p className="section-description" dangerouslySetInnerHTML={{ __html: support_content }}></p>
      </section>

      <section className="homepage-section">
        <h2 className="section-title">{ changelog['heading' + lang] }</h2>
        <ul className="changelog-container">
          {arrayChangelog.map(({ node }, index) =>
            <li className="changelog-item" key={ index }>
              <p>
                <span className="changelog-date-icon"><i className="material-icons">insert_invitation</i></span>
                <span className="changelog-date">{ node.date } <span className="changelog-version"> - { node.version }</span></span>
              </p>
              <p className="change-log-title">{ node['content' + lang] }</p>
            </li>
          )}
        </ul>
      </section>
    </div>
  )
}

export default IndexPage

export const query = graphql`
  query HomepageQuery {
    allTranslationsXlsxHomepage {
      edges {
        node {
          key
          heading
          content
          heading_nl
          content_nl
          heading_de
          content_de
        }
      }
    }
    allTranslationsXlsxFeatures {
      edges {
        node {
          feature
          feature_nl
          feature_de
        }
      }
    }
    allTranslationsXlsxChangelog {
      edges {
        node {
          date
          version
          content
          content_nl
          content_de
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js